import { Power3 } from 'gsap';
import Text from '../../graphics/Text';
import DraggablePreset from './DraggablePreset';
import { NONE } from '../../constants/DropShadow';
import GraphicMask from '../../graphics/GraphicMask';
import {
  getAlignX,
  getCenterY,
  getFixAboveY,
  getFixBelowY,
  getXAccountingForAnchor,
  getYAccountingForAnchor,
} from '../../utils/CoordinateCalculator';

export default class Scrolling extends DraggablePreset {
  constructor(app) {
    super(app);
    this.texts = [];
    this.textMask = new GraphicMask();
    this.container.addChild(this.textMask.mask);
  }

  update(model) {
    model = { ...model, dropShadow: NONE }; // disable drop shadow for this preset
    super.update(model);

    if (this.texts.length) {
      this.container.removeChild(...this.texts);
    }

    if (!this.numTextLines) {
      this.texts = [];
      return;
    }

    const animationDuration = this.duration / (this.numTextLines + 1);

    let maxLineWidth = 0;
    let maxLineHeight = 0;
    this.texts = this.textLines.map((line) => {
      const text = new Text(this.app, line);
      text.updateStyle(model);
      maxLineWidth = Math.max(text.outerControls.width, maxLineWidth);
      maxLineHeight = Math.max(text.outerControls.height, maxLineHeight);
      text.mask = this.textMask.mask;
      return text;
    });
    this.container.addChild(...this.texts);

    // update content and size
    this.setDraggableRoot(maxLineHeight, maxLineWidth);

    this.textMask.x = getXAccountingForAnchor(this.root);
    this.textMask.y = getYAccountingForAnchor(this.root);
    this.textMask.width = this.root.width;
    this.textMask.height = this.root.height;

    this.textMask.render();

    this.texts.forEach((text, index) => {
      // set starting values
      text.outerControls.x = getAlignX(text.outerControls, this.root);
      text.outerControls.y = getFixBelowY(text.outerControls, this.root);

      // Build our animations
      this.animate(text.outerControls)
        .to(
          {
            y: getCenterY(text.outerControls, this.root),
            duration: animationDuration,
            ease: Power3.easeInOut,
          },
          index * animationDuration
        )
        .to(
          {
            y: getFixAboveY(text.outerControls, this.root),
            duration: animationDuration,
            ease: Power3.easeInOut,
          },
          (index + 1) * animationDuration
        );
    });
  }
}
